import { render } from "./AppGaratshteterore.vue?vue&type=template&id=394dc7f1"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__